import React, { lazy } from 'react'
import { Router, Redirect, Route, Switch } from 'react-router-dom'
import { ResetCSS } from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js/bignumber'
import useEagerConnect from 'hooks/useEagerConnect'
import { usePollBlockNumber } from 'state/block/hooks'
import { usePollCoreFarmData } from 'state/farms/hooks'
import { useFetchProfile } from 'state/profile/hooks'
import { DatePickerPortal } from 'components/DatePicker'
import VoteClosed from 'views/VoteClosed'
import Locked from 'views/Locked'
import Vesting from 'views/Vesting'
import Presale from 'views/Presale'
import Nem from 'views/BuyCrypto'
import Faucet from 'views/Faucet'
import Faucet1 from 'views/Faucet1'
import Faucet2 from 'views/Faucet2'
import Faucet3 from 'views/Faucet3'
import Limit from 'views/LimitOrders'
import Faucet4 from 'views/Faucet4'
import Faucet5 from 'views/Faucet5'
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import { ToastListener } from './contexts/ToastsContext'
import PageLoader from './components/Loader/PageLoader'
import EasterEgg from './components/EasterEgg'
import history from './routerHistory'
// Views included in the main bundle
import Pools from './views/Pools'
import FarmPools from './views/FarmPools'
import Vote from './views/Vote'
import Donation from './views/Donation'
import ApeSwap from './views/ApeSwap'
import RadioShack from './views/RadioShack'
import Biswap from './views/Biswap'
import Babydoge from './views/BabyDoge'
import Swap from './views/Swap'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity,
} from './views/AddLiquidity/redirects'
import {
  RedirectDuplicateTokenIds2,
  RedirectOldAddLiquidityPathStructure2,
  RedirectToAddLiquidity2,
} from './views/AddLiquidity2/redirects'
import {
  RedirectDuplicateTokenIds3,
  RedirectOldAddLiquidityPathStructure3,
  RedirectToAddLiquidity3,
} from './views/AddLiquidity4/redirects'
import {
  RedirectDuplicateTokenIds4,
  RedirectOldAddLiquidityPathStructure4,
  RedirectToAddLiquidity4,
} from './views/AddLiquidity5/redirects'
import {
  RedirectDuplicateTokenIds5,
  RedirectOldAddLiquidityPathStructure5,
  RedirectToAddLiquidity5,
} from './views/AddLiquidity6/redirects'
import RedirectOldRemoveLiquidityPathStructure from './views/RemoveLiquidity/redirects'
import RedirectOldRemoveLiquidityPathStructure2 from './views/RemoveLiquidity2/redirects'
import RedirectOldRemoveLiquidityPathStructure4 from './views/RemoveLiquidity4/redirects'
import RedirectOldRemoveLiquidityPathStructure5 from './views/RemoveLiquidity5/redirects'
import RedirectOldRemoveLiquidityPathStructure6 from './views/RemoveLiquidity6/redirects'
import { RedirectPathToSwapOnly, RedirectToSwap } from './views/Swap/redirects'

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page
const Home = lazy(() => import('./views/Home'))
const Listing = lazy(() => import('./views/Listing'))
const Partnership = lazy(() => import('./views/Partnership'))
const ListingForm = lazy(() => import('./views/ListingForm'))
const Farms = lazy(() => import('./views/Farms'))
const FarmAuction = lazy(() => import('./views/FarmAuction'))
const Lottery = lazy(() => import('./views/Lottery'))
const Ifos = lazy(() => import('./views/Ifos'))
const NotFound = lazy(() => import('./views/NotFound'))
const Collectibles = lazy(() => import('./views/Collectibles'))
const Teams = lazy(() => import('./views/Teams'))
const Team = lazy(() => import('./views/Teams/Team'))
const Profile = lazy(() => import('./views/Profile'))
const TradingCompetition = lazy(() => import('./views/TradingCompetition'))
const Predictions = lazy(() => import('./views/Predictions'))
const AddLiquidity = lazy(() => import('./views/AddLiquidity'))
const AddLiquidity2 = lazy(() => import('./views/AddLiquidity2'))
const AddLiquidity4 = lazy(() => import('./views/AddLiquidity4'))
const AddLiquidity5 = lazy(() => import('./views/AddLiquidity5'))
const AddLiquidity6 = lazy(() => import('./views/AddLiquidity6'))
const Liquidity = lazy(() => import('./views/Pool'))
const Liquidity2 = lazy(() => import('./views/Pool2'))
const Liquidity4 = lazy(() => import('./views/Pool4'))
const Liquidity5 = lazy(() => import('./views/Pool5'))
const Liquidity6 = lazy(() => import('./views/Pool6'))
const PoolFinder = lazy(() => import('./views/PoolFinder'))
const PoolFinder2 = lazy(() => import('./views/PoolFinder2'))
const PoolFinder4 = lazy(() => import('./views/PoolFinder4'))
const PoolFinder5 = lazy(() => import('./views/PoolFinder5'))
const PoolFinder6 = lazy(() => import('./views/PoolFinder6'))
const RemoveLiquidity = lazy(() => import('./views/RemoveLiquidity'))
const RemoveLiquidity2 = lazy(() => import('./views/RemoveLiquidity2'))
const RemoveLiquidity4 = lazy(() => import('./views/RemoveLiquidity4'))
const RemoveLiquidity5 = lazy(() => import('./views/RemoveLiquidity5'))
const RemoveLiquidity6 = lazy(() => import('./views/RemoveLiquidity6'))
const WalletTransactions = lazy(() => import('./views/WalletTransactions'))

// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  usePollBlockNumber()
  useEagerConnect()
  useFetchProfile()
  usePollCoreFarmData()

  return (
    <Router history={history}>
      <ResetCSS />
      <GlobalStyle />
      <Menu>
        <SuspenseWithChunkError fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route exact path="/farms/auction">
              <FarmAuction />
            </Route>
            <Route exact path="/whitepaper">
              <Listing />
            </Route>
            <Route exact path="/voting/open">
              <Vote />
            </Route>
            <Route exact path="/voting/closed">
              <VoteClosed />
            </Route> 
            <Route exact path="/donation"> 
              <Donation />
            </Route> 
            <Route exact path="/partnership">
              <Partnership />
            </Route>
            <Route exact path="/listingform">
              <ListingForm />
            </Route>
            <Route path="/buywithfiat">
              <Nem />
            </Route>
            <Route path="/mining">
              <Farms />
            </Route> 
            <Route path="/pools">
              <Pools />
            </Route>
            <Route path="/be2mining">
              <FarmPools />
            </Route>
            <Route path="/airdrops">
              <Faucet />
            </Route> 
            <Route path="/airdropslgc">
              <Faucet1 />
            </Route>
            <Route path="/airdropshvi">
              <Faucet2 />
            </Route>
            <Route path="/airdropsbvc">
              <Faucet3 />
            </Route>
            <Route path="/airdropslamea">
              <Faucet4 />
            </Route>
            <Route path="/airdropsfrtc">
              <Faucet5 />
            </Route>
            <Route path="/lockedstaking">
              <Locked />
            </Route>
            <Route path="/discount">
              <Vesting />
            </Route>
            <Route path="/presale">
              <Presale />
            </Route>
            <Route path="/lottery">
              <Lottery />
            </Route>
            <Route path="/ifo">
              <Ifos />
            </Route>
            <Route path="/activity">
              <WalletTransactions />
            </Route>
            <Route path="/limit-orders">
              <Limit />
            </Route>
            <Route path="/collectibles">
              <Collectibles />
            </Route>
            <Route exact path="/teams">
              <Teams />
            </Route>
            <Route path="/teams/:id">
              <Team />
            </Route>
            <Route path="/profile">
              <Profile />
            </Route>
            <Route path="/competition">
              <TradingCompetition />
            </Route>
            <Route path="/prediction">
              <Predictions />
            </Route>
            {/* Using this format because these components use routes injected props. We need to rework them with hooks */}
            <Route exact strict path="/swap">
              <Swap />
            </Route>
            <Route exact strict path="/apeswap">
              <ApeSwap />
            </Route>
            <Route exact strict path="/radioshack">
              <RadioShack />
            </Route>
            <Route exact strict path="/biswap">
              <Biswap />
            </Route>
            <Route exact strict path="/babydogeswap">
              <Babydoge />
            </Route>
            <Route exact strict path="/swap/:outputCurrency">
              <RedirectToSwap />
            </Route>
            <Route exact strict path="/send">
              <RedirectPathToSwapOnly />
            </Route>
            <Route exact strict path="/find">
              <PoolFinder />
            </Route>
            <Route exact strict path="/apefind">
              <PoolFinder2 />
            </Route>
            <Route exact strict path="/radiofind">
              <PoolFinder4 />
            </Route>
            <Route exact strict path="/biswapfind">
              <PoolFinder5 />
            </Route>
            <Route exact strict path="/babydogefind">
              <PoolFinder6 />
            </Route>
            <Route exact strict path="/liquidity">
              <Liquidity />
            </Route>
            <Route exact strict path="/apeliquidity">
              <Liquidity2 />
            </Route>
            <Route exact strict path="/radioliquidity">
              <Liquidity4 />
            </Route>
            <Route exact strict path="/biswapliquidity">
              <Liquidity5 />
            </Route>
            <Route exact strict path="/babydogeliquidity">
              <Liquidity6 />
            </Route>
            <Route exact strict path="/create">
              <RedirectToAddLiquidity />
            </Route>
            <Route exact strict path="/createape">
              <RedirectToAddLiquidity2 />
            </Route>
            <Route exact strict path="/createradio">
              <RedirectToAddLiquidity3 />
            </Route>
            <Route exact strict path="/createbiswap">
              <RedirectToAddLiquidity4 />
            </Route>
            <Route exact strict path="/createbabydoge">
              <RedirectToAddLiquidity5 />
            </Route>
            <Route exact path="/add">
              <AddLiquidity />
            </Route>
            <Route exact path="/addapeliquidity">
              <AddLiquidity2 />
            </Route>
            <Route exact path="/addradioliquidity">
              <AddLiquidity4 />
            </Route>
            <Route exact path="/addbiswapliquidity">
              <AddLiquidity5 />
            </Route>
            <Route exact path="/addbabydogeliquidity">
              <AddLiquidity6 />
            </Route>
            <Route exact path="/add/:currencyIdA">
              <RedirectOldAddLiquidityPathStructure />
            </Route>
            <Route exact path="/add/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds />
            </Route>
            <Route exact path="/addapeliquidity/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds2 />
            </Route>
            <Route exact path="/addradioliquidity/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds3 />
            </Route>
            <Route exact path="/addbiswapliquidity/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds4 />
            </Route>
            <Route exact path="/addbabydogeliquidity/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds5 />
            </Route>
            <Route exact path="/create">
              <AddLiquidity />
            </Route>
            <Route exact path="/createape">
              <AddLiquidity2 />
            </Route>
            <Route exact path="/createradio">
              <AddLiquidity4 />
            </Route>
            <Route exact path="/createbiswap">
              <AddLiquidity5 />
            </Route>
            <Route exact path="/createbabydoge">
              <AddLiquidity6 />
            </Route>
            <Route exact path="/create/:currencyIdA">
              <RedirectOldAddLiquidityPathStructure2 />
            </Route>
            <Route exact path="/create/:currencyIdA">
              <RedirectOldAddLiquidityPathStructure3 />
            </Route>
            <Route exact path="/create/:currencyIdA">
              <RedirectOldAddLiquidityPathStructure4 />
            </Route>
            <Route exact path="/create/:currencyIdA">
              <RedirectOldAddLiquidityPathStructure5 />
            </Route>
            <Route exact path="/create/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds />
            </Route>
            <Route exact path="/createape/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds2 />
            </Route>
            <Route exact path="/createradio/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds3 />
            </Route>
            <Route exact path="/createbiswap/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds4 />
            </Route>
            <Route exact path="/createbabydoge/:currencyIdA/:currencyIdB">
              <RedirectDuplicateTokenIds5 />
            </Route>
            <Route exact strict path="/remove/:tokens">
              <RedirectOldRemoveLiquidityPathStructure />
            </Route>
            <Route exact strict path="/removeape/:tokens">
              <RedirectOldRemoveLiquidityPathStructure2 />
            </Route>
            <Route exact strict path="/removeradio/:tokens">
              <RedirectOldRemoveLiquidityPathStructure4 />
            </Route>
            <Route exact strict path="/removebiswap/:tokens">
              <RedirectOldRemoveLiquidityPathStructure5 />
            </Route>
            <Route exact strict path="/removebabydoge/:tokens">
              <RedirectOldRemoveLiquidityPathStructure6 />
            </Route>
            <Route exact strict path="/remove/:currencyIdA/:currencyIdB">
              <RemoveLiquidity />
            </Route>
            <Route exact strict path="/removeape/:currencyIdA/:currencyIdB">
              <RemoveLiquidity2 />
            </Route>
            <Route exact strict path="/removeradio/:currencyIdA/:currencyIdB">
              <RemoveLiquidity4 />
            </Route>
            <Route exact strict path="/removebiswap/:currencyIdA/:currencyIdB">
              <RemoveLiquidity5 />
            </Route>
            <Route exact strict path="/removebabydoge/:currencyIdA/:currencyIdB">
              <RemoveLiquidity6 />
            </Route>


            {/* Redirect */}
            <Route path="/pool">
              <Redirect to="/liquidity" />
            </Route>
            <Route path="/pool2">
              <Redirect to="/apeliquidity" />
            </Route>
            <Route path="/pool4">
              <Redirect to="/radioliquidity" />
            </Route>
            <Route path="/pool5">
              <Redirect to="/biswapliquidity" />
            </Route>
            <Route path="/pool6">
              <Redirect to="/babydogeliquidity" />
            </Route>
            <Route path="/staking">
              <Redirect to="/pools/all" />
            </Route>
            <Route path="/syrup">
              <Redirect to="/pools/all" />
            </Route>
            <Route path="/nft">
              <Redirect to="/collectibles" />
            </Route>

            {/* 404 */}
            <Route component={NotFound} />
          </Switch>
        </SuspenseWithChunkError>
      </Menu>
      <EasterEgg iterations={2} />
      <ToastListener />
      <DatePickerPortal />
    </Router>
  )
}

export default React.memo(App)
